import _ from 'underscore';

export const initial = {
    cards: [],
    error: null,
    interps: null,
    positions: [],
    subject: null,
    button_text: 'reveal the meaning',
};

export function loaded(state, payload) {
    return { ...state, interps: payload };
}

export function error(state, payload) {
    return { ...state, error: payload };
}

export function picked(state, payload) {
    return { ...state, cards: _.uniq(state.cards.concat(payload.card)) };
}

export function cards(state, payload) {
    return { ...state, cards: payload };
}

export function positions(state, payload) {
    return { ...state, positions: payload };
}

export function type(state, payload) {
    return { ...state, type: payload };
}

export function subject(state, payload) {
    return { ...state, subject: payload };
}

export function button_text(state, payload) {
    return { ...state, button_text: payload };
}

export function sampleInterp(state, payload) {
    return { ...state, sample_interps: payload };
}

export function loadSaved(state, payload) {
    return { ...state, cards: payload };
}



// WEBPACK FOOTER //
// ./app/reducers/tarot-reading.js